import React from 'react';
import i18n from '@i18next/i18n';

// 重新生成图片弹窗
export const ReplaceSlidePCTitle = () => (
    <div style={{ margin: '0 4px -8px', fontSize: 16, fontWeight: 'bold' }}>{i18n.t('AI 单页美化')}</div>
);
